import { Tag } from 'antd';
import { useDebtsReportQuery, useLazyExportDebtsXlsxQuery } from '@/entities/reports';
import type { DebtsReportRow } from '@/entities/reports';
import { ReportPage } from '@/shared/ui';
import type { ResponsiveColumns } from '@/shared/ui';

const STATUS_COLOR: Record<DebtsReportRow['status'], string> = { YOU_OWE_US: 'success', WE_OWE_THEM: 'error' };

/** §13, §7: контрагенты с ненулевым балансом. */
export function DebtsReportPage() {
  const { data, isFetching } = useDebtsReportQuery(undefined, { pollingInterval: 30_000 });
  const [exportXlsx] = useLazyExportDebtsXlsxQuery();

  const columns: ResponsiveColumns<DebtsReportRow> = [
    { title: 'Контрагент', dataIndex: 'counterpartyName' },
    {
      title: 'Кто должен',
      dataIndex: 'status',
      width: 140,
      mobile: 'badge',
      render: (_v, row) => <Tag color={STATUS_COLOR[row.status]}>{row.statusLabel}</Tag>,
    },
    // Сумма без знака: «Мы должны 9270.00», а не «Мы должны −9270.00».
    { title: 'Сумма', dataIndex: 'amount', width: 120, align: 'right' },
    { title: 'Неоплаченных документов', dataIndex: 'unpaidDocumentsCount', width: 170, align: 'right' },
  ];

  return (
    <ReportPage
      title="Долги"
      columns={columns}
      data={data?.rows ?? []}
      loading={isFetching}
      rowKey="counterpartyId"
      onExport={() => exportXlsx().unwrap()}
      exportFilename="Долги.xlsx"
    />
  );
}
